//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { USER_ENROLLMENT_NAMESPACE, USER_TOKEN_NAMESPACE } from '../constants/namespaces';
export class ClientBase {
  /**
   * authorization token value
   */

  public getBaseUrl(url: string, url2: string) {
    return 'https://api-test-prodoc.azurewebsites.net';
  }
  protected transformOptions(options: any) {
    const oauth = localStorage.getItem(USER_TOKEN_NAMESPACE);
    const userEnrollmentId = localStorage.getItem(USER_ENROLLMENT_NAMESPACE);

    if (oauth) {
      options.headers['authorization'] = 'Bearer ' + oauth;
    }
    if (userEnrollmentId) {
      options.headers['EmployeeEnrollment'] = userEnrollmentId;
    }
    var tenant = window.location.host.split('.')[0];

    options.headers['tenant'] = tenant;

    return Promise.resolve(options);
  }
}

export class CalendarItemClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<CalendarItem> {
        let url_ = this.baseUrl + "/api/calendar?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CalendarItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarItem;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarItem>(null as any);
    }

    /**
     * @return Success
     */
    update(body: CalendarItem): Promise<CalendarItem> {
        let url_ = this.baseUrl + "/api/calendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<CalendarItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarItem;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarItem>(null as any);
    }

    /**
     * @return Success
     */
    add(body: CalendarItem[]): Promise<CalendarItem[]> {
        let url_ = this.baseUrl + "/api/calendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<CalendarItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarItem[]>(null as any);
    }

    /**
     * @return Success
     */
    getManyByGroupId(groupId: string): Promise<CalendarItem[]> {
        let url_ = this.baseUrl + "/api/calendar/getByGroupId/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyByGroupId(_response);
        });
    }

    protected processGetManyByGroupId(response: Response): Promise<CalendarItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarItem[]>(null as any);
    }

    /**
     * @return Success
     */
    getFromEmployeeEnrollment(employeeEnrollmentId: string): Promise<CalendarItem[]> {
        let url_ = this.baseUrl + "/api/calendar/getFromEmployeeEnrollment/{employeeEnrollmentId}";
        if (employeeEnrollmentId === undefined || employeeEnrollmentId === null)
            throw new Error("The parameter 'employeeEnrollmentId' must be defined.");
        url_ = url_.replace("{employeeEnrollmentId}", encodeURIComponent("" + employeeEnrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFromEmployeeEnrollment(_response);
        });
    }

    protected processGetFromEmployeeEnrollment(response: Response): Promise<CalendarItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarItem[]>(null as any);
    }

    /**
     * @return Success
     */
    getFromCitizenEnrollment(citizenEnrollmentId: string): Promise<CalendarItem[]> {
        let url_ = this.baseUrl + "/api/calendar/getFromCitizenEnrollment/{citizenEnrollmentId}";
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined.");
        url_ = url_.replace("{citizenEnrollmentId}", encodeURIComponent("" + citizenEnrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFromCitizenEnrollment(_response);
        });
    }

    protected processGetFromCitizenEnrollment(response: Response): Promise<CalendarItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarItem[]>(null as any);
    }

    /**
     * @return Success
     */
    getFromHealthCare(citizenEnrollmentId: string, healthCareParentEnum: string): Promise<CalendarItem[]> {
        let url_ = this.baseUrl + "/api/calendar/getFromHealthCare/{citizenEnrollmentId}/{healthCareParentEnum}";
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined.");
        url_ = url_.replace("{citizenEnrollmentId}", encodeURIComponent("" + citizenEnrollmentId));
        if (healthCareParentEnum === undefined || healthCareParentEnum === null)
            throw new Error("The parameter 'healthCareParentEnum' must be defined.");
        url_ = url_.replace("{healthCareParentEnum}", encodeURIComponent("" + healthCareParentEnum));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFromHealthCare(_response);
        });
    }

    protected processGetFromHealthCare(response: Response): Promise<CalendarItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarItem[]>(null as any);
    }

    /**
     * @return Success
     */
    addToGroup(groupId: string, body: CalendarItem[]): Promise<CalendarItem[]> {
        let url_ = this.baseUrl + "/api/calendar/addToGroup/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddToGroup(_response);
        });
    }

    protected processAddToGroup(response: Response): Promise<CalendarItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarItem[]>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Promise<CalendarItem> {
        let url_ = this.baseUrl + "/api/calendar/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<CalendarItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CalendarItem;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarItem>(null as any);
    }
}

export class CenterClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<Center> {
        let url_ = this.baseUrl + "/api/center?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Center> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center>(null as any);
    }

    /**
     * @return Success
     */
    add(body: Center): Promise<Center> {
        let url_ = this.baseUrl + "/api/center";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Center> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: Center | null | undefined): Promise<Center> {
        let url_ = this.baseUrl + "/api/center";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Center> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center>(null as any);
    }

    /**
     * @return Success
     */
    search(searchString: string): Promise<Center[]> {
        let url_ = this.baseUrl + "/api/center/search/{searchString}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Center[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllCreatedBy(): Promise<Center[]> {
        let url_ = this.baseUrl + "/api/center/getAllCreatedBy";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCreatedBy(_response);
        });
    }

    protected processGetAllCreatedBy(response: Response): Promise<Center[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getByLeader(employeeId: string | null | undefined): Promise<Center[]> {
        let url_ = this.baseUrl + "/api/center/getByLeader?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByLeader(_response);
        });
    }

    protected processGetByLeader(response: Response): Promise<Center[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getByAdministrative(employeeId: string | null | undefined): Promise<Center[]> {
        let url_ = this.baseUrl + "/api/center/getByLeaderOrAdministrative?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByAdministrative(_response);
        });
    }

    protected processGetByAdministrative(response: Response): Promise<Center[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center[]>(null as any);
    }

    /**
     * @return Success
     */
    getMany(body: string[]): Promise<Center[]> {
        let url_ = this.baseUrl + "/api/center/getMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMany(_response);
        });
    }

    protected processGetMany(response: Response): Promise<Center[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center[]>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/center/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getManyCentersFromEmployee(employeeId: string): Promise<Center[]> {
        let url_ = this.baseUrl + "/api/center/getManyCentersFromEmployee/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyCentersFromEmployee(_response);
        });
    }

    protected processGetManyCentersFromEmployee(response: Response): Promise<Center[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center[]>(null as any);
    }

    /**
     * @return Success
     */
    getMyCenters(): Promise<Center[]> {
        let url_ = this.baseUrl + "/api/center/getMyCenters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyCenters(_response);
        });
    }

    protected processGetMyCenters(response: Response): Promise<Center[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Center[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Center[]>(null as any);
    }
}

export class CitizenClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getMany(): Promise<Citizen> {
        let url_ = this.baseUrl + "/api/citizen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMany(_response);
        });
    }

    protected processGetMany(response: Response): Promise<Citizen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Citizen;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Citizen>(null as any);
    }

    /**
     * @return Success
     */
    add(body: Citizen): Promise<Citizen> {
        let url_ = this.baseUrl + "/api/citizen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Citizen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Citizen;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Citizen>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: Citizen | null | undefined): Promise<Citizen> {
        let url_ = this.baseUrl + "/api/citizen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Citizen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Citizen;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Citizen>(null as any);
    }

    /**
     * @return Success
     */
    get(citizenId: string): Promise<Citizen> {
        let url_ = this.baseUrl + "/api/citizen/{citizenId}";
        if (citizenId === undefined || citizenId === null)
            throw new Error("The parameter 'citizenId' must be defined.");
        url_ = url_.replace("{citizenId}", encodeURIComponent("" + citizenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Citizen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Citizen;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Citizen>(null as any);
    }

    /**
     * @return Success
     */
    search(searchString: string): Promise<Citizen[]> {
        let url_ = this.baseUrl + "/api/citizen/search/{searchString}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Citizen[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Citizen[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Citizen[]>(null as any);
    }

    /**
     * @return Success
     */
    exists(cpr: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/citizen/exists/{cpr}";
        if (cpr === undefined || cpr === null)
            throw new Error("The parameter 'cpr' must be defined.");
        url_ = url_.replace("{cpr}", encodeURIComponent("" + cpr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExists(_response);
        });
    }

    protected processExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getByCpr(cpr: string): Promise<Citizen> {
        let url_ = this.baseUrl + "/api/citizen/getByCpr/{cpr}";
        if (cpr === undefined || cpr === null)
            throw new Error("The parameter 'cpr' must be defined.");
        url_ = url_.replace("{cpr}", encodeURIComponent("" + cpr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByCpr(_response);
        });
    }

    protected processGetByCpr(response: Response): Promise<Citizen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Citizen;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Citizen>(null as any);
    }

    /**
     * @return Success
     */
    getByForeignId(foreignId: string): Promise<Citizen> {
        let url_ = this.baseUrl + "/api/citizen/getByForeignId/{foreignId}";
        if (foreignId === undefined || foreignId === null)
            throw new Error("The parameter 'foreignId' must be defined.");
        url_ = url_.replace("{foreignId}", encodeURIComponent("" + foreignId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByForeignId(_response);
        });
    }

    protected processGetByForeignId(response: Response): Promise<Citizen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Citizen;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Citizen>(null as any);
    }

    /**
     * @return Success
     */
    getCitizenByEnrollmentId(citizenEnrollmentId: string): Promise<Citizen> {
        let url_ = this.baseUrl + "/api/citizen/getCitizenByEnrollmentId/{citizenEnrollmentId}";
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined.");
        url_ = url_.replace("{citizenEnrollmentId}", encodeURIComponent("" + citizenEnrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCitizenByEnrollmentId(_response);
        });
    }

    protected processGetCitizenByEnrollmentId(response: Response): Promise<Citizen> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Citizen;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Citizen>(null as any);
    }
}

export class CitizenEnrollmentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<CitizenEnrollment> {
        let url_ = this.baseUrl + "/api/citizenenrollment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<CitizenEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CitizenEnrollment;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CitizenEnrollment>(null as any);
    }

    /**
     * @return Success
     */
    getByCitizen(id: string, onlyActive: boolean): Promise<CitizenEnrollment[]> {
        let url_ = this.baseUrl + "/api/citizenenrollment/getByCitizen/{id}/{onlyActive}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (onlyActive === undefined || onlyActive === null)
            throw new Error("The parameter 'onlyActive' must be defined.");
        url_ = url_.replace("{onlyActive}", encodeURIComponent("" + onlyActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByCitizen(_response);
        });
    }

    protected processGetByCitizen(response: Response): Promise<CitizenEnrollment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CitizenEnrollment[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CitizenEnrollment[]>(null as any);
    }

    /**
     * @return Success
     */
    getMany(body: string[]): Promise<CitizenEnrollment[]> {
        let url_ = this.baseUrl + "/api/citizenenrollment/getMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMany(_response);
        });
    }

    protected processGetMany(response: Response): Promise<CitizenEnrollment[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CitizenEnrollment[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CitizenEnrollment[]>(null as any);
    }

    /**
     * @return Success
     */
    discharge(id: string, dischargeDate: Date, dischargeCause: string): Promise<void> {
        let url_ = this.baseUrl + "/api/citizenenrollment/discharge/{id}/{dischargeDate}/{dischargeCause}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dischargeDate === undefined || dischargeDate === null)
            throw new Error("The parameter 'dischargeDate' must be defined.");
        url_ = url_.replace("{dischargeDate}", encodeURIComponent(dischargeDate ? "" + dischargeDate.toISOString() : "null"));
        if (dischargeCause === undefined || dischargeCause === null)
            throw new Error("The parameter 'dischargeCause' must be defined.");
        url_ = url_.replace("{dischargeCause}", encodeURIComponent("" + dischargeCause));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDischarge(_response);
        });
    }

    protected processDischarge(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    search(searchString: string): Promise<CitizenEnrollmentResult[]> {
        let url_ = this.baseUrl + "/api/citizenenrollment/search/{searchString}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<CitizenEnrollmentResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CitizenEnrollmentResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CitizenEnrollmentResult[]>(null as any);
    }

    /**
     * @return Success
     */
    add(body: CitizenEnrollment): Promise<CitizenEnrollment> {
        let url_ = this.baseUrl + "/api/citizenenrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<CitizenEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CitizenEnrollment;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CitizenEnrollment>(null as any);
    }

    /**
     * @return Success
     */
    update(body: CitizenEnrollment): Promise<CitizenEnrollment> {
        let url_ = this.baseUrl + "/api/citizenenrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<CitizenEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CitizenEnrollment;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CitizenEnrollment>(null as any);
    }

    /**
     * @return Success
     */
    getManyByDepartments(body: DepartmentDto): Promise<CitizenEnrollmentResult[]> {
        let url_ = this.baseUrl + "/api/citizenenrollment/bydepartments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyByDepartments(_response);
        });
    }

    protected processGetManyByDepartments(response: Response): Promise<CitizenEnrollmentResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CitizenEnrollmentResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CitizenEnrollmentResult[]>(null as any);
    }

    /**
     * @return Success
     */
    getMyCitizenEnrollments(): Promise<CitizenEnrollmentResult[]> {
        let url_ = this.baseUrl + "/api/citizenenrollment/getMyCitizenEnrollments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyCitizenEnrollments(_response);
        });
    }

    protected processGetMyCitizenEnrollments(response: Response): Promise<CitizenEnrollmentResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CitizenEnrollmentResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CitizenEnrollmentResult[]>(null as any);
    }
}

export class DepartmentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getMany(body: string[]): Promise<Department[]> {
        let url_ = this.baseUrl + "/api/department/getMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMany(_response);
        });
    }

    protected processGetMany(response: Response): Promise<Department[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Department[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department[]>(null as any);
    }

    /**
     * @return Success
     */
    getManyFromCenter(body: string[]): Promise<Department[]> {
        let url_ = this.baseUrl + "/api/department/getManyFromCenter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyFromCenter(_response);
        });
    }

    protected processGetManyFromCenter(response: Response): Promise<Department[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Department[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Promise<Department> {
        let url_ = this.baseUrl + "/api/department/id?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Department> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Department;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department>(null as any);
    }

    /**
     * @return Success
     */
    add(body: Department): Promise<Department> {
        let url_ = this.baseUrl + "/api/department";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Department> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Department;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: Department | null | undefined): Promise<Department> {
        let url_ = this.baseUrl + "/api/department";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Department> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Department;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department>(null as any);
    }

    /**
     * @return Success
     */
    search(searchString: string): Promise<Department[]> {
        let url_ = this.baseUrl + "/api/department/search/{searchString}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Department[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Department[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Department[]>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/department/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMyDepartments(): Promise<DepartmentResult[]> {
        let url_ = this.baseUrl + "/api/department/getMyDepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyDepartments(_response);
        });
    }

    protected processGetMyDepartments(response: Response): Promise<DepartmentResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentResult[]>(null as any);
    }
}

export class DepartmentCitizenEnrollmentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    search(searchString: string): Promise<DepartmentCitizenEnrollmentResult> {
        let url_ = this.baseUrl + "/api/departmentcitizenenrollment/search/{searchString}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<DepartmentCitizenEnrollmentResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DepartmentCitizenEnrollmentResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentCitizenEnrollmentResult>(null as any);
    }
}

export class EmployeeClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(): Promise<Employee> {
        let url_ = this.baseUrl + "/api/employee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Employee> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Employee;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee>(null as any);
    }

    /**
     * @return Success
     */
    add(body: Employee): Promise<Employee> {
        let url_ = this.baseUrl + "/api/employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Employee> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Employee;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: Employee | null | undefined): Promise<Employee> {
        let url_ = this.baseUrl + "/api/employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Employee> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Employee;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee>(null as any);
    }

    /**
     * @return Success
     */
    getById(id: string): Promise<Employee> {
        let url_ = this.baseUrl + "/api/employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<Employee> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Employee;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    exists(cpr: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/employee/exists/{cpr}";
        if (cpr === undefined || cpr === null)
            throw new Error("The parameter 'cpr' must be defined.");
        url_ = url_.replace("{cpr}", encodeURIComponent("" + cpr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExists(_response);
        });
    }

    protected processExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getByCpr(cpr: string): Promise<Employee> {
        let url_ = this.baseUrl + "/api/employee/getByCpr/{cpr}";
        if (cpr === undefined || cpr === null)
            throw new Error("The parameter 'cpr' must be defined.");
        url_ = url_.replace("{cpr}", encodeURIComponent("" + cpr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByCpr(_response);
        });
    }

    protected processGetByCpr(response: Response): Promise<Employee> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Employee;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee>(null as any);
    }

    /**
     * @return Success
     */
    search(searchString: string): Promise<Employee[]> {
        let url_ = this.baseUrl + "/api/employee/search/{searchString}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Employee[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Employee[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee[]>(null as any);
    }

    /**
     * @return Success
     */
    getMany(body: string[]): Promise<Employee[]> {
        let url_ = this.baseUrl + "/api/employee/getMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMany(_response);
        });
    }

    protected processGetMany(response: Response): Promise<Employee[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Employee[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee[]>(null as any);
    }
}

export class EmployeeEnrollmentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<EmployeeEnrollment> {
        let url_ = this.baseUrl + "/api/employeeenrollment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<EmployeeEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeEnrollment;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeEnrollment>(null as any);
    }

    /**
     * @return Success
     */
    add(body: EmployeeEnrollment): Promise<EmployeeEnrollment> {
        let url_ = this.baseUrl + "/api/employeeenrollment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<EmployeeEnrollment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeEnrollment;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeEnrollment>(null as any);
    }

    /**
     * @return Success
     */
    getByEmployee(id: string, onlyActive: boolean): Promise<EmployeeEnrollmentResult[]> {
        let url_ = this.baseUrl + "/api/employeeenrollment/getByEmployee/{id}/{onlyActive}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (onlyActive === undefined || onlyActive === null)
            throw new Error("The parameter 'onlyActive' must be defined.");
        url_ = url_.replace("{onlyActive}", encodeURIComponent("" + onlyActive));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByEmployee(_response);
        });
    }

    protected processGetByEmployee(response: Response): Promise<EmployeeEnrollmentResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeEnrollmentResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeEnrollmentResult[]>(null as any);
    }

    /**
     * @return Success
     */
    discharge(id: string, dischargeDate: Date): Promise<void> {
        let url_ = this.baseUrl + "/api/employeeenrollment/discharge/{id}/{dischargeDate}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dischargeDate === undefined || dischargeDate === null)
            throw new Error("The parameter 'dischargeDate' must be defined.");
        url_ = url_.replace("{dischargeDate}", encodeURIComponent(dischargeDate ? "" + dischargeDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDischarge(_response);
        });
    }

    protected processDischarge(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getManyByDepartments(body: DepartmentDto): Promise<EmployeeEnrollmentResult[]> {
        let url_ = this.baseUrl + "/api/employeeenrollment/bydepartments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyByDepartments(_response);
        });
    }

    protected processGetManyByDepartments(response: Response): Promise<EmployeeEnrollmentResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeEnrollmentResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeEnrollmentResult[]>(null as any);
    }

    /**
     * @return Success
     */
    getManyByEmployee(): Promise<EmployeeEnrollmentResult[]> {
        let url_ = this.baseUrl + "/api/employeeenrollment/getManyByEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyByEmployee(_response);
        });
    }

    protected processGetManyByEmployee(response: Response): Promise<EmployeeEnrollmentResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeEnrollmentResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeEnrollmentResult[]>(null as any);
    }

    /**
     * @return Success
     */
    search(searchText: string): Promise<EmployeeEnrollmentResult[]> {
        let url_ = this.baseUrl + "/api/employeeenrollment/search/{searchText}";
        if (searchText === undefined || searchText === null)
            throw new Error("The parameter 'searchText' must be defined.");
        url_ = url_.replace("{searchText}", encodeURIComponent("" + searchText));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<EmployeeEnrollmentResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeEnrollmentResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeEnrollmentResult[]>(null as any);
    }
}

export class FavoriteClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getManyFromEmployeeEnrollment(employeeEnrollmentId: string): Promise<Favorite[]> {
        let url_ = this.baseUrl + "/api/favorite/{employeeEnrollmentId}";
        if (employeeEnrollmentId === undefined || employeeEnrollmentId === null)
            throw new Error("The parameter 'employeeEnrollmentId' must be defined.");
        url_ = url_.replace("{employeeEnrollmentId}", encodeURIComponent("" + employeeEnrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyFromEmployeeEnrollment(_response);
        });
    }

    protected processGetManyFromEmployeeEnrollment(response: Response): Promise<Favorite[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Favorite[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Favorite[]>(null as any);
    }

    /**
     * @return Success
     */
    add(body: Favorite): Promise<void> {
        let url_ = this.baseUrl + "/api/favorite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/favorite/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FileClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param jwtToken (optional) 
     * @param origin (optional) 
     * @return Success
     */
    download(blobFileName: string, jwtToken: string | null | undefined, origin: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/file/download/{blobFileName}";
        if (blobFileName === undefined || blobFileName === null)
            throw new Error("The parameter 'blobFileName' must be defined.");
        url_ = url_.replace("{blobFileName}", encodeURIComponent("" + blobFileName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (jwtToken !== null && jwtToken !== undefined)
            content_.append("jwtToken", jwtToken.toString());
        if (origin !== null && origin !== undefined)
            content_.append("origin", origin.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param tagId (optional) 
     * @param file (optional) 
     * @return Success
     */
    upload(entityId: string, uploadType: string, documentType: string, tagId: string[] | null | undefined, file: FileParameter | null | undefined): Promise<FileShare> {
        let url_ = this.baseUrl + "/api/file/upload/{entityId}/{uploadType}/{documentType}?";
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined.");
        url_ = url_.replace("{entityId}", encodeURIComponent("" + entityId));
        if (uploadType === undefined || uploadType === null)
            throw new Error("The parameter 'uploadType' must be defined.");
        url_ = url_.replace("{uploadType}", encodeURIComponent("" + uploadType));
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined.");
        url_ = url_.replace("{documentType}", encodeURIComponent("" + documentType));
        if (tagId !== undefined && tagId !== null)
            tagId && tagId.forEach(item => { url_ += "tagId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: Response): Promise<FileShare> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileShare;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileShare>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: FileShareDto | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/file/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delete(body: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/file/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getManyByDocumentType(documentType: string): Promise<FileShareDto[]> {
        let url_ = this.baseUrl + "/api/file/getManyByDocumentType/{documentType}";
        if (documentType === undefined || documentType === null)
            throw new Error("The parameter 'documentType' must be defined.");
        url_ = url_.replace("{documentType}", encodeURIComponent("" + documentType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyByDocumentType(_response);
        });
    }

    protected processGetManyByDocumentType(response: Response): Promise<FileShareDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileShareDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileShareDto[]>(null as any);
    }
}

export class ForgotPasswordClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    forgot(username: string): Promise<void> {
        let url_ = this.baseUrl + "/api/forgotpassword/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForgot(_response);
        });
    }

    protected processForgot(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    updatePassword(passwordId: string, password: string): Promise<void> {
        let url_ = this.baseUrl + "/api/forgotpassword/{passwordId}/{password}";
        if (passwordId === undefined || passwordId === null)
            throw new Error("The parameter 'passwordId' must be defined.");
        url_ = url_.replace("{passwordId}", encodeURIComponent("" + passwordId));
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined.");
        url_ = url_.replace("{password}", encodeURIComponent("" + password));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ForumClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    add(body: ForumMessage): Promise<ForumMessage> {
        let url_ = this.baseUrl + "/api/forum";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<ForumMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForumMessage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForumMessage>(null as any);
    }

    /**
     * @return Success
     */
    update(body: ForumMessage): Promise<ForumMessage> {
        let url_ = this.baseUrl + "/api/forum";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ForumMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForumMessage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForumMessage>(null as any);
    }

    /**
     * @param messageId (optional) 
     * @return Success
     */
    delete(messageId: string | null | undefined): Promise<ForumMessage> {
        let url_ = this.baseUrl + "/api/forum/messageId?";
        if (messageId !== undefined && messageId !== null)
            url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<ForumMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForumMessage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForumMessage>(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Promise<ForumMessage[]> {
        let url_ = this.baseUrl + "/api/forum/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<ForumMessage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForumMessage[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForumMessage[]>(null as any);
    }
}

export class FrontEndErrorLoggerClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    log(body: string): Promise<void> {
        let url_ = this.baseUrl + "/api/frontenderrorlogger";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLog(_response);
        });
    }

    protected processLog(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class GoalClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param citizenEnrollmentId (optional) 
     * @return Success
     */
    get(citizenEnrollmentId: string | null | undefined): Promise<Goal> {
        let url_ = this.baseUrl + "/api/goal?";
        if (citizenEnrollmentId !== undefined && citizenEnrollmentId !== null)
            url_ += "citizenEnrollmentId=" + encodeURIComponent("" + citizenEnrollmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Goal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Goal;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Goal>(null as any);
    }

    /**
     * @return Success
     */
    add(body: Goal): Promise<Goal> {
        let url_ = this.baseUrl + "/api/goal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Goal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Goal;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Goal>(null as any);
    }

    /**
     * @return Success
     */
    update(body: Goal): Promise<Goal> {
        let url_ = this.baseUrl + "/api/goal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Goal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Goal;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Goal>(null as any);
    }

    /**
     * @return Success
     */
    getByCitizenEnrollment(citizenEnrollmentId: string, onlyActve: boolean): Promise<GoalResult[]> {
        let url_ = this.baseUrl + "/api/goal/getByCitizenEnrollment/{citizenEnrollmentId}/{onlyActve}";
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined.");
        url_ = url_.replace("{citizenEnrollmentId}", encodeURIComponent("" + citizenEnrollmentId));
        if (onlyActve === undefined || onlyActve === null)
            throw new Error("The parameter 'onlyActve' must be defined.");
        url_ = url_.replace("{onlyActve}", encodeURIComponent("" + onlyActve));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByCitizenEnrollment(_response);
        });
    }

    protected processGetByCitizenEnrollment(response: Response): Promise<GoalResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GoalResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalResult[]>(null as any);
    }

    /**
     * @return Success
     */
    delete(goalId: string): Promise<Goal> {
        let url_ = this.baseUrl + "/api/goal/delete/{goalId}";
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<Goal> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Goal;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Goal>(null as any);
    }
}

export class GoalScorerClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<GoalScorer> {
        let url_ = this.baseUrl + "/api/goalscorer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<GoalScorer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GoalScorer;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalScorer>(null as any);
    }

    /**
     * @return Success
     */
    getByGoalId(goalId: string): Promise<GoalScorer[]> {
        let url_ = this.baseUrl + "/api/goalscorer/GetByGoalId/{goalId}";
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByGoalId(_response);
        });
    }

    protected processGetByGoalId(response: Response): Promise<GoalScorer[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GoalScorer[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalScorer[]>(null as any);
    }

    /**
     * @return Success
     */
    add(body: GoalScorer): Promise<GoalScorer> {
        let url_ = this.baseUrl + "/api/goalscorer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<GoalScorer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GoalScorer;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalScorer>(null as any);
    }

    /**
     * @return Success
     */
    update(body: GoalScorer): Promise<GoalScorer> {
        let url_ = this.baseUrl + "/api/goalscorer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<GoalScorer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GoalScorer;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalScorer>(null as any);
    }

    /**
     * @return Success
     */
    delete(goalId: string): Promise<GoalScorer> {
        let url_ = this.baseUrl + "/api/goalscorer/delete/{goalId}";
        if (goalId === undefined || goalId === null)
            throw new Error("The parameter 'goalId' must be defined.");
        url_ = url_.replace("{goalId}", encodeURIComponent("" + goalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<GoalScorer> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GoalScorer;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GoalScorer>(null as any);
    }
}

export class HealthCareClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    add(body: HealthCare): Promise<HealthCare> {
        let url_ = this.baseUrl + "/api/healthcare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<HealthCare> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HealthCare;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCare>(null as any);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<HealthCare> {
        let url_ = this.baseUrl + "/api/healthcare?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<HealthCare> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HealthCare;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCare>(null as any);
    }

    /**
     * @return Success
     */
    getLatestByCitizenEnrollmentId(citizenEnrollmentId: string): Promise<HealthCare[]> {
        let url_ = this.baseUrl + "/api/healthcare/getLatestByCitizenEnrollmentId/{citizenEnrollmentId}";
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined.");
        url_ = url_.replace("{citizenEnrollmentId}", encodeURIComponent("" + citizenEnrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestByCitizenEnrollmentId(_response);
        });
    }

    protected processGetLatestByCitizenEnrollmentId(response: Response): Promise<HealthCare[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HealthCare[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCare[]>(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Promise<HealthCareDto[]> {
        let url_ = this.baseUrl + "/api/healthcare/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<HealthCareDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HealthCareDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCareDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getByCitizenEnrollment(citizenEnrollmentId: string): Promise<HealthCareDto[]> {
        let url_ = this.baseUrl + "/api/healthcare/getByCitizenEnrollment/{citizenEnrollmentId}";
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined.");
        url_ = url_.replace("{citizenEnrollmentId}", encodeURIComponent("" + citizenEnrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByCitizenEnrollment(_response);
        });
    }

    protected processGetByCitizenEnrollment(response: Response): Promise<HealthCareDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HealthCareDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCareDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(citizenEnrollmentId: string, body: HealthCareDto | null | undefined): Promise<HealthCare[]> {
        let url_ = this.baseUrl + "/api/healthcare/search/citizenEnrollmentId?";
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined and cannot be null.");
        else
            url_ += "citizenEnrollmentId=" + encodeURIComponent("" + citizenEnrollmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<HealthCare[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HealthCare[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthCare[]>(null as any);
    }
}

export class KeepAliveClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(): Promise<void> {
        let url_ = this.baseUrl + "/api/keepalive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    encrypt(p: string): Promise<string> {
        let url_ = this.baseUrl + "/api/keepalive/encrypt/{p}";
        if (p === undefined || p === null)
            throw new Error("The parameter 'p' must be defined.");
        url_ = url_.replace("{p}", encodeURIComponent("" + p));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEncrypt(_response);
        });
    }

    protected processEncrypt(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class MeasurementClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    add(body: Measurement): Promise<Measurement> {
        let url_ = this.baseUrl + "/api/measurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Measurement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Measurement;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Measurement>(null as any);
    }

    /**
     * @return Success
     */
    update(body: Measurement): Promise<Measurement> {
        let url_ = this.baseUrl + "/api/measurement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Measurement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Measurement;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Measurement>(null as any);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<Measurement> {
        let url_ = this.baseUrl + "/api/measurement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Measurement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Measurement;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Measurement>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Promise<Measurement> {
        let url_ = this.baseUrl + "/api/measurement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<Measurement> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Measurement;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Measurement>(null as any);
    }

    /**
     * @return Success
     */
    getByType(citizenEnrollmentId: string, measurementtype: string): Promise<Measurement[]> {
        let url_ = this.baseUrl + "/api/measurement/getFromCitizenEnrollmentByType/{citizenEnrollmentId}/{measurementtype}";
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined.");
        url_ = url_.replace("{citizenEnrollmentId}", encodeURIComponent("" + citizenEnrollmentId));
        if (measurementtype === undefined || measurementtype === null)
            throw new Error("The parameter 'measurementtype' must be defined.");
        url_ = url_.replace("{measurementtype}", encodeURIComponent("" + measurementtype));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByType(_response);
        });
    }

    protected processGetByType(response: Response): Promise<Measurement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Measurement[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Measurement[]>(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Promise<MeasurementDto[]> {
        let url_ = this.baseUrl + "/api/measurement/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<MeasurementDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MeasurementDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementDto[]>(null as any);
    }
}

export class MedicineClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<Medicine> {
        let url_ = this.baseUrl + "/api/medicine/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Medicine> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Medicine;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Medicine>(null as any);
    }

    /**
     * @return Success
     */
    getManyByCitizen(citizenId: string): Promise<Medicine[]> {
        let url_ = this.baseUrl + "/api/medicine/getManyByCitizen/{citizenId}";
        if (citizenId === undefined || citizenId === null)
            throw new Error("The parameter 'citizenId' must be defined.");
        url_ = url_.replace("{citizenId}", encodeURIComponent("" + citizenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyByCitizen(_response);
        });
    }

    protected processGetManyByCitizen(response: Response): Promise<Medicine[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Medicine[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Medicine[]>(null as any);
    }

    /**
     * @return Success
     */
    getManyByCitizenWithoutCalendarItem(citizenId: string): Promise<Medicine[]> {
        let url_ = this.baseUrl + "/api/medicine/getManyByCitizenWithoutCalendarItem/{citizenId}";
        if (citizenId === undefined || citizenId === null)
            throw new Error("The parameter 'citizenId' must be defined.");
        url_ = url_.replace("{citizenId}", encodeURIComponent("" + citizenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyByCitizenWithoutCalendarItem(_response);
        });
    }

    protected processGetManyByCitizenWithoutCalendarItem(response: Response): Promise<Medicine[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Medicine[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Medicine[]>(null as any);
    }

    /**
     * @param noCalendarItem (optional) 
     * @param body (optional) 
     * @return Success
     */
    add(noCalendarItem: boolean | null | undefined, body: Medicine | null | undefined): Promise<Medicine> {
        let url_ = this.baseUrl + "/api/medicine?";
        if (noCalendarItem !== undefined && noCalendarItem !== null)
            url_ += "noCalendarItem=" + encodeURIComponent("" + noCalendarItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Medicine> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Medicine;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Medicine>(null as any);
    }

    /**
     * @param noCalendarItem (optional) 
     * @param body (optional) 
     * @return Success
     */
    update(noCalendarItem: boolean | null | undefined, body: Medicine | null | undefined): Promise<Medicine> {
        let url_ = this.baseUrl + "/api/medicine?";
        if (noCalendarItem !== undefined && noCalendarItem !== null)
            url_ += "noCalendarItem=" + encodeURIComponent("" + noCalendarItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Medicine> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Medicine;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Medicine>(null as any);
    }

    /**
     * @return Success
     */
    search(text: string): Promise<StringProductListKeyValuePair[]> {
        let url_ = this.baseUrl + "/api/medicine/searchMedicine/{text}";
        if (text === undefined || text === null)
            throw new Error("The parameter 'text' must be defined.");
        url_ = url_.replace("{text}", encodeURIComponent("" + text));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<StringProductListKeyValuePair[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StringProductListKeyValuePair[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringProductListKeyValuePair[]>(null as any);
    }

    /**
     * @return Success
     */
    details(productNumber: string): Promise<ProductDetails> {
        let url_ = this.baseUrl + "/api/medicine/details/{productNumber}";
        if (productNumber === undefined || productNumber === null)
            throw new Error("The parameter 'productNumber' must be defined.");
        url_ = url_.replace("{productNumber}", encodeURIComponent("" + productNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: Response): Promise<ProductDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDetails;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductDetails>(null as any);
    }

    /**
     * @return Success
     */
    getPnLast24Hours(productNumber: string, citizenEnrollmentId: string): Promise<Medicine[]> {
        let url_ = this.baseUrl + "/api/medicine/GetPnLast24Hours/{productNumber}/{citizenEnrollmentId}";
        if (productNumber === undefined || productNumber === null)
            throw new Error("The parameter 'productNumber' must be defined.");
        url_ = url_.replace("{productNumber}", encodeURIComponent("" + productNumber));
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined.");
        url_ = url_.replace("{citizenEnrollmentId}", encodeURIComponent("" + citizenEnrollmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPnLast24Hours(_response);
        });
    }

    protected processGetPnLast24Hours(response: Response): Promise<Medicine[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Medicine[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Medicine[]>(null as any);
    }
}

export class NoteClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<Note> {
        let url_ = this.baseUrl + "/api/note?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Note> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Note;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Note>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: Note | null | undefined): Promise<Note> {
        let url_ = this.baseUrl + "/api/note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Note> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Note;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Note>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: Note | null | undefined): Promise<Note> {
        let url_ = this.baseUrl + "/api/note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<Note> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Note;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Note>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Promise<Note> {
        let url_ = this.baseUrl + "/api/note/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<Note> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Note;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Note>(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/note/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getManyByDepartment(departmentId: string): Promise<Note[]> {
        let url_ = this.baseUrl + "/api/note/getManyByDepartment/{departmentId}";
        if (departmentId === undefined || departmentId === null)
            throw new Error("The parameter 'departmentId' must be defined.");
        url_ = url_.replace("{departmentId}", encodeURIComponent("" + departmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyByDepartment(_response);
        });
    }

    protected processGetManyByDepartment(response: Response): Promise<Note[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Note[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Note[]>(null as any);
    }
}

export class ResourceCalendarClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    getResourceCalendarItems(departmentId: string, resourceCalendarPage: string): Promise<ResourceCalendarItem[]> {
        let url_ = this.baseUrl + "/api/resourcecalendar/get-resource-calendar-items/departmentId/{departmentId}/resource-calendar-page/{resourceCalendarPage}";
        if (departmentId === undefined || departmentId === null)
            throw new Error("The parameter 'departmentId' must be defined.");
        url_ = url_.replace("{departmentId}", encodeURIComponent("" + departmentId));
        if (resourceCalendarPage === undefined || resourceCalendarPage === null)
            throw new Error("The parameter 'resourceCalendarPage' must be defined.");
        url_ = url_.replace("{resourceCalendarPage}", encodeURIComponent("" + resourceCalendarPage));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResourceCalendarItems(_response);
        });
    }

    protected processGetResourceCalendarItems(response: Response): Promise<ResourceCalendarItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceCalendarItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceCalendarItem[]>(null as any);
    }

    /**
     * @return Success
     */
    addResourceCalendarItem(body: ResourceCalendarItem): Promise<ResourceCalendarItem> {
        let url_ = this.baseUrl + "/api/resourcecalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddResourceCalendarItem(_response);
        });
    }

    protected processAddResourceCalendarItem(response: Response): Promise<ResourceCalendarItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceCalendarItem;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceCalendarItem>(null as any);
    }

    /**
     * @return Success
     */
    updateResourceCalendarItem(body: ResourceCalendarItem): Promise<ResourceCalendarItem> {
        let url_ = this.baseUrl + "/api/resourcecalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateResourceCalendarItem(_response);
        });
    }

    protected processUpdateResourceCalendarItem(response: Response): Promise<ResourceCalendarItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceCalendarItem;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceCalendarItem>(null as any);
    }

    /**
     * @return Success
     */
    deleteResourceCalendarItem(id: string): Promise<ResourceCalendarItem> {
        let url_ = this.baseUrl + "/api/resourcecalendar/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteResourceCalendarItem(_response);
        });
    }

    protected processDeleteResourceCalendarItem(response: Response): Promise<ResourceCalendarItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceCalendarItem;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceCalendarItem>(null as any);
    }
}

export class RiskClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Promise<Risk> {
        let url_ = this.baseUrl + "/api/risk/id?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Risk> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Risk;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Risk>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: Risk | null | undefined): Promise<Risk> {
        let url_ = this.baseUrl + "/api/risk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Risk> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Risk;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Risk>(null as any);
    }
}

export class TagClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<Tag> {
        let url_ = this.baseUrl + "/api/tag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<Tag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag>(null as any);
    }

    /**
     * @return Success
     */
    search(searchString: string, departmentId: string): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/tag/search/{searchString}/{departmentId}";
        if (searchString === undefined || searchString === null)
            throw new Error("The parameter 'searchString' must be defined.");
        url_ = url_.replace("{searchString}", encodeURIComponent("" + searchString));
        if (departmentId === undefined || departmentId === null)
            throw new Error("The parameter 'departmentId' must be defined.");
        url_ = url_.replace("{departmentId}", encodeURIComponent("" + departmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * @return Success
     */
    getManyByDepartments(departmentId: string): Promise<Tag[]> {
        let url_ = this.baseUrl + "/api/tag/getManyByDepartments/{departmentId}";
        if (departmentId === undefined || departmentId === null)
            throw new Error("The parameter 'departmentId' must be defined.");
        url_ = url_.replace("{departmentId}", encodeURIComponent("" + departmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyByDepartments(_response);
        });
    }

    protected processGetManyByDepartments(response: Response): Promise<Tag[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    add(body: Tag | null | undefined): Promise<Tag> {
        let url_ = this.baseUrl + "/api/tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<Tag> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Tag;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Tag>(null as any);
    }
}

export class TokenClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    create(username: string, password: string): Promise<Token> {
        let url_ = this.baseUrl + "/api/token/{username}/{password}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined.");
        url_ = url_.replace("{password}", encodeURIComponent("" + password));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<Token> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Token;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Token>(null as any);
    }
}

export class UseOfForceClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @param createdDate (optional) 
     * @return Success
     */
    add(schema: string, version: string, citizenEnrollmentId: string, createdDate: string | null | undefined, body: any): Promise<string> {
        let url_ = this.baseUrl + "/api/useofforce/{schema}/{version}/{citizenEnrollmentId}?";
        if (schema === undefined || schema === null)
            throw new Error("The parameter 'schema' must be defined.");
        url_ = url_.replace("{schema}", encodeURIComponent("" + schema));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (citizenEnrollmentId === undefined || citizenEnrollmentId === null)
            throw new Error("The parameter 'citizenEnrollmentId' must be defined.");
        url_ = url_.replace("{citizenEnrollmentId}", encodeURIComponent("" + citizenEnrollmentId));
        if (createdDate !== undefined && createdDate !== null)
            url_ += "createdDate=" + encodeURIComponent("" + createdDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    update(id: string, body: any): Promise<UseOfForceDto> {
        let url_ = this.baseUrl + "/api/useofforce/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<UseOfForceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UseOfForceDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UseOfForceDto>(null as any);
    }

    /**
     * @return Success
     */
    get(id: string): Promise<UseOfForceDto> {
        let url_ = this.baseUrl + "/api/useofforce/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UseOfForceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UseOfForceDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UseOfForceDto>(null as any);
    }

    /**
     * @return Success
     */
    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/useofforce/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    sendToDepartmentManager(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/useofforce/sendToDepartmentManager/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendToDepartmentManager(_response);
        });
    }

    protected processSendToDepartmentManager(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    sendToCenterManager(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/useofforce/sendToCenterManager/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendToCenterManager(_response);
        });
    }

    protected processSendToCenterManager(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    sendToEmployee(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/useofforce/sendToEmployee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendToEmployee(_response);
        });
    }

    protected processSendToEmployee(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    sendToAuthority(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/useofforce/sendToAuthority/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendToAuthority(_response);
        });
    }

    protected processSendToAuthority(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param citizenId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getMany(showOnlyMine: boolean, citizenId: string | null | undefined, status: any | null | undefined): Promise<UseOfForceDto[]> {
        let url_ = this.baseUrl + "/api/useofforce/getMany/{showOnlyMine}?";
        if (showOnlyMine === undefined || showOnlyMine === null)
            throw new Error("The parameter 'showOnlyMine' must be defined.");
        url_ = url_.replace("{showOnlyMine}", encodeURIComponent("" + showOnlyMine));
        if (citizenId !== undefined && citizenId !== null)
            url_ += "citizenId=" + encodeURIComponent("" + citizenId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMany(_response);
        });
    }

    protected processGetMany(response: Response): Promise<UseOfForceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UseOfForceDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UseOfForceDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAll(): Promise<UseOfForceDto[]> {
        let url_ = this.baseUrl + "/api/useofforce/getAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: Response): Promise<UseOfForceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UseOfForceDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UseOfForceDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getDepartmentCountValues(): Promise<UseOfForceCalculations> {
        let url_ = this.baseUrl + "/api/useofforce/getDepartmentCountValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDepartmentCountValues(_response);
        });
    }

    protected processGetDepartmentCountValues(response: Response): Promise<UseOfForceCalculations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UseOfForceCalculations;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UseOfForceCalculations>(null as any);
    }

    /**
     * @return Success
     */
    getCitizenCountValues(citizenId: string): Promise<UseOfForceCalculations> {
        let url_ = this.baseUrl + "/api/useofforce/getCitizenCountValues/{citizenId}";
        if (citizenId === undefined || citizenId === null)
            throw new Error("The parameter 'citizenId' must be defined.");
        url_ = url_.replace("{citizenId}", encodeURIComponent("" + citizenId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCitizenCountValues(_response);
        });
    }

    protected processGetCitizenCountValues(response: Response): Promise<UseOfForceCalculations> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UseOfForceCalculations;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UseOfForceCalculations>(null as any);
    }

    /**
     * @return Success
     */
    downloadPdf(useOfForceId: string): Promise<HttpResponseMessage> {
        let url_ = this.baseUrl + "/api/useofforce/downloadPdf/{useOfForceId}";
        if (useOfForceId === undefined || useOfForceId === null)
            throw new Error("The parameter 'useOfForceId' must be defined.");
        url_ = url_.replace("{useOfForceId}", encodeURIComponent("" + useOfForceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadPdf(_response);
        });
    }

    protected processDownloadPdf(response: Response): Promise<HttpResponseMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HttpResponseMessage;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HttpResponseMessage>(null as any);
    }
}

export enum AuthType {
    Employee = "Employee",
    Manager = "Manager",
    Admin = "Admin",
}

export interface CalendarItem {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    calendarItemType: CalendarItemType;
    fromDate: Date;
    toDate: Date;
    title?: string | undefined;
    citizenId?: string | undefined;
    citizenEnrollmentId?: string | undefined;
    done?: boolean | undefined;
    allday?: boolean | undefined;
    note?: string | undefined;
    groupId?: string | undefined;
    calendarStatus?: CalendarStatus | undefined;
    isAccepted?: boolean | undefined;
    isPrivate?: boolean | undefined;
    isEditable?: boolean | undefined;
    departmentId?: string | undefined;
    employeeId: string;
    employeeEnrollmentId: string;
    goalIds?: string[] | undefined;
    privateAppointment?: boolean | undefined;
    healthAppointment?: boolean | undefined;
    health?: HealthCareParentType[] | undefined;
    entityId?: string | undefined;
    entityObjectType?: string | undefined;
    pnEvaluated?: boolean | undefined;
}

export enum CalendarItemType {
    Normal = "Normal",
    Note = "Note",
    Medicine = "Medicine",
    UseOfForce = "UseOfForce",
    Measurement = "Measurement",
    PN = "PN",
    GoalFrom = "GoalFrom",
    GoalTo = "GoalTo",
    GoalEvaluation = "GoalEvaluation",
    HealthCare = "HealthCare",
    HealthCareNote = "HealthCareNote",
    TimeTrack = "TimeTrack",
    BirthDay = "BirthDay",
}

export enum CalendarStatus {
    Unanswered = "Unanswered",
    Accepted = "Accepted",
    Declined = "Declined",
}

export interface Center {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    name?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    employeeEnrollmentLeaderId?: string | undefined;
    employeeEnrollment2LeaderId?: string[] | undefined;
    employeeEnrollmentAdministrativeId?: string[] | undefined;
}

export interface Citizen {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    cpr: string;
    firstname: string;
    lastname: string;
    phone?: string | undefined;
    address?: string | undefined;
    alternativeAddress?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    foreignId?: string | undefined;
    cave?: string | undefined;
    diagnoses?: string | undefined;
    vaccines?: string | undefined;
    typeOfConviction?: TypeOfConviction | undefined;
    riskAssessmentGreen?: string | undefined;
    riskAssessmentYellow?: string | undefined;
    riskAssessmentRed?: string | undefined;
    actMunicipallity?: string | undefined;
    payMunicipallity?: string | undefined;
    actSocialworker?: string | undefined;
    paySocialworker?: string | undefined;
    convictionStartDate?: Date | undefined;
    convictionEndtDate?: Date | undefined;
    readonly name?: string | undefined;
}

export interface CitizenEnrollment {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    departmentId?: string | undefined;
    citizenId?: string | undefined;
    enrollmentDate?: Date | undefined;
    dischargedDate?: Date | undefined;
    enrolledFrom?: EnrollFromType | undefined;
    dischargeCause?: DischargeCause | undefined;
    color?: string | undefined;
    riskAssessmentGreen?: string | undefined;
    riskAssessmentGreenAct?: string | undefined;
    riskAssessmentYellow?: string | undefined;
    riskAssessmentYellowAct?: string | undefined;
    riskAssessmentRed?: string | undefined;
    riskAssessmentRedAct?: string | undefined;
}

export interface CitizenEnrollmentResult {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    departmentId?: string | undefined;
    citizenId?: string | undefined;
    enrollmentDate?: Date | undefined;
    dischargedDate?: Date | undefined;
    enrolledFrom?: EnrollFromType | undefined;
    actMunicipallity?: string | undefined;
    payMunicipallity?: string | undefined;
    socialworker?: string | undefined;
    dischargeCause?: DischargeCause | undefined;
    color?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    cpr?: string | undefined;
    readonly departmentName?: string | undefined;
    readonly centerName?: string | undefined;
}

export interface Department {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    centerId?: string | undefined;
    name?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    employeeEnrollmentLeaderId?: string | undefined;
    employeeEnrollment2LeaderId?: string[] | undefined;
    employeeEnrollmentAdministrativeId?: string[] | undefined;
}

export interface DepartmentCitizenEnrollmentResult {
    departments?: Department[] | undefined;
    citizenEnrollments?: CitizenEnrollmentResult[] | undefined;
}

export interface DepartmentDto {
    departmentIds?: string[] | undefined;
}

export interface DepartmentResult {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    centerId?: string | undefined;
    name?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    address?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    employeeEnrollmentLeaderId?: string | undefined;
    employeeEnrollment2LeaderId?: string[] | undefined;
    employeeEnrollmentAdministrativeId?: string[] | undefined;
    centerName?: string | undefined;
}

export enum DischargeCause {
    None = "None",
    EightteenPlus = "EightteenPlus",
    Death = "Death",
    OwnWish = "OwnWish",
    Expelled = "Expelled",
    InternalMove = "InternalMove",
    Vacated = "Vacated",
    ExternalOffer = "ExternalOffer",
    GoalsAchieved = "GoalsAchieved",
    OwnResidence = "OwnResidence",
    FosterFamily = "FosterFamily",
    OtherReason = "OtherReason",
}

export enum DocumentType {
    Document = "Document",
    Procedures = "Procedures",
}

export enum DoseUnit {
    Saet = "Saet",
    Eid = "Eid",
    Ml = "Ml",
    G = "G",
    Gdosis = "Gdosis",
    Hep = "Hep",
    InitialSaet = "InitialSaet",
    Mg = "Mg",
    MgDosis = "MgDosis",
    PPM = "PPM",
    Mikg = "Mikg",
    MikgDosis = "MikgDosis",
    MikgTid = "MikgTid",
    MikgTime = "MikgTime",
    Htgl = "Htgl",
    Wv = "Wv",
}

export interface Employee {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    cpr?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    address?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    phone?: string | undefined;
    phonePrivate?: string | undefined;
    email?: string | undefined;
    emailPrivate?: string | undefined;
    username?: string | undefined;
    password?: string | undefined;
    authType?: AuthType | undefined;
    readonly fullName?: string | undefined;
}

export interface EmployeeEnrollment {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    departmentId?: string | undefined;
    employeeId?: string | undefined;
    enrollmentDate?: Date | undefined;
    position?: Position | undefined;
    dischargedDate?: Date | undefined;
    color?: string | undefined;
}

export interface EmployeeEnrollmentResult {
    id?: string | undefined;
    departmentId?: string | undefined;
    employeeId?: string | undefined;
    enrollmentDate?: Date | undefined;
    position?: Position | undefined;
    dischargedDate?: Date | undefined;
    color?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    departmentName?: string | undefined;
    email?: string | undefined;
    created?: Date | undefined;
}

export enum EnrollFromType {
    PrivateLiving = "PrivateLiving",
    Psychiatry = "Psychiatry",
    Municipally = "Municipally",
    Regional = "Regional",
    PrivateOffer = "PrivateOffer",
    Street = "Street",
    FosterHome = "FosterHome",
}

export interface Favorite {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    entityId?: string | undefined;
    employeeEnrollmentId?: string | undefined;
    favoriteType?: FavoriteType | undefined;
}

export enum FavoriteType {
    Citizen = "Citizen",
    MainMenu = "MainMenu",
    SidebarOpenClose = "SidebarOpenClose",
}

export interface FileShare {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    blobFileName?: string | undefined;
    fileName?: string | undefined;
    citizenEnrollmentId?: string | undefined;
    departmentId?: string | undefined;
    uploadType?: UploadType | undefined;
    documentType?: DocumentType | undefined;
    description?: string | undefined;
    tagIds?: string[] | undefined;
    readByEmployeeIds?: string[] | undefined;
}

export interface FileShareDto {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    blobFileName?: string | undefined;
    fileName?: string | undefined;
    citizenEnrollmentId?: string | undefined;
    departmentId?: string | undefined;
    uploadType?: UploadType | undefined;
    documentType?: DocumentType | undefined;
    description?: string | undefined;
    tagIds?: string[] | undefined;
    readByEmployeeIds?: string[] | undefined;
    tags?: Tag[] | undefined;
    citizen?: Citizen | undefined;
}

export interface ForumComment {
    comment?: string | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    created?: Date | undefined;
    deleted?: boolean | undefined;
}

export interface ForumMessage {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    header?: string | undefined;
    text?: string | undefined;
    comments?: ForumComment[] | undefined;
    pinned?: boolean | undefined;
}

export interface Goal {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    citizenEnrollmentId?: string | undefined;
    goalType?: GoalType | undefined;
    goalStatus?: GoalStatus | undefined;
    goalMethod?: GoalMethod | undefined;
    goalMethodTheme?: GoalMethodTheme | undefined;
    fromDate?: Date | undefined;
    evaluationDate?: Date | undefined;
    evaluationText?: string | undefined;
    toDate?: Date | undefined;
    parentGoalId?: string | undefined;
    employeeEnrollmentIds?: string[] | undefined;
    score?: number | undefined;
}

export enum GoalMethod {
    VUM2 = "VUM2",
    ICS = "ICS",
    FSIII = "FSIII",
}

export enum GoalMethodTheme {
    VUM2_SelfCare = "VUM2_SelfCare",
    VUM2_Communication = "VUM2_Communication",
    VUM2_Mobility = "VUM2_Mobility",
    VUM2_PracticalTasks = "VUM2_PracticalTasks",
    VUM2_Relationships = "VUM2_Relationships",
    VUM2_CommunityLife = "VUM2_CommunityLife",
    ICS_HousingEmploymentAndFinances = "ICS_HousingEmploymentAndFinances",
    ICS_DayCareSchoolConditionsAndLearning = "ICS_DayCareSchoolConditionsAndLearning",
    ICS_FamilyRelationshipsAndBackground = "ICS_FamilyRelationshipsAndBackground",
    ICS_LeisureRelationshipsAndFriendships = "ICS_LeisureRelationshipsAndFriendships",
    ICS_SocialNetwork = "ICS_SocialNetwork",
    ICS_StimulationAndGuidance = "ICS_StimulationAndGuidance",
    ICS_HealthConditions = "ICS_HealthConditions",
    ICS_SafeCareEnvironment = "ICS_SafeCareEnvironment",
    ICS_DevelopmentAndBehavior = "ICS_DevelopmentAndBehavior",
    ICS_RelationshipSupport = "ICS_RelationshipSupport",
    FSIII_FunctionLevel = "FSIII_FunctionLevel",
    FSIII_MovementDevice = "FSIII_MovementDevice",
    FSIII_Nutrition = "FSIII_Nutrition",
    FSIII_SkinAndMucousMembranes = "FSIII_SkinAndMucousMembranes",
    FSIII_Communication = "FSIII_Communication",
    FSIII_PsychosocialConditions = "FSIII_PsychosocialConditions",
    FSIII_RespirationAndCirculation = "FSIII_RespirationAndCirculation",
    FSIII_Sexuality = "FSIII_Sexuality",
    FSIII_PainAndSensoryImpressions = "FSIII_PainAndSensoryImpressions",
    FSIII_SleepAndWhich = "FSIII_SleepAndWhich",
    FSIII_KnowledgeAndDevelopment = "FSIII_KnowledgeAndDevelopment",
    FSIII_SeparationOfWasteProducts = "FSIII_SeparationOfWasteProducts",
}

export interface GoalResult {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    citizenEnrollmentId?: string | undefined;
    goalType?: GoalType | undefined;
    goalStatus?: GoalStatus | undefined;
    goalMethod?: GoalMethod | undefined;
    goalMethodTheme?: GoalMethodTheme | undefined;
    fromDate?: Date | undefined;
    evaluationDate?: Date | undefined;
    evaluationText?: string | undefined;
    toDate?: Date | undefined;
    parentGoalId?: string | undefined;
    employeeEnrollmentIds?: string[] | undefined;
    score?: number | undefined;
    subGoals?: Goal[] | undefined;
    goalScorer?: GoalScorer[] | undefined;
}

export interface GoalScorer {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    score: number;
    goalId: string;
    description?: string | undefined;
}

export enum GoalStatus {
    OnGoing = "OnGoing",
    Paused = "Paused",
    Achieved = "Achieved",
    NotAchieved = "NotAchieved",
}

export enum GoalType {
    DevelopFunctionalAbility = "DevelopFunctionalAbility",
    MaintainFunctionality = "MaintainFunctionality",
    LimitLossOfFunction = "LimitLossOfFunction",
}

export interface HealthCare {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    care?: HealthCareType | undefined;
    problem?: HealthCareProblem | undefined;
    citizenAct?: HealthCareCitizenAct | undefined;
    description?: string | undefined;
    action?: string | undefined;
    partners?: string | undefined;
    citizenEnrollmentId?: string | undefined;
    isActive?: boolean | undefined;
    medicineIds?: string[] | undefined;
    blobFileNames?: string[] | undefined;
}

export enum HealthCareCitizenAct {
    Undecided = "Undecided",
    Yes = "Yes",
    No = "No",
}

export interface HealthCareDto {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    care?: HealthCareType | undefined;
    problem?: HealthCareProblem | undefined;
    citizenAct?: HealthCareCitizenAct | undefined;
    description?: string | undefined;
    action?: string | undefined;
    partners?: string | undefined;
    citizenEnrollmentId?: string | undefined;
    isActive?: boolean | undefined;
    medicineIds?: string[] | undefined;
    blobFileNames?: string[] | undefined;
    citizenName?: string | undefined;
}

export enum HealthCareParentType {
    None = "None",
    FunctionLevel = "FunctionLevel",
    MovementApparatus = "MovementApparatus",
    Nutrition = "Nutrition",
    SkinAndMucousMembranes = "SkinAndMucousMembranes",
    Communication = "Communication",
    PsychosocialConditions = "PsychosocialConditions",
    RespirationAndCirculation = "RespirationAndCirculation",
    Sexuality = "Sexuality",
    PainAndSensoryImpressions = "PainAndSensoryImpressions",
    SleepAndRest = "SleepAndRest",
    KnowledgeAndDevelopment = "KnowledgeAndDevelopment",
    SeparationOfWasteProducts = "SeparationOfWasteProducts",
}

export enum HealthCareProblem {
    Currently = "Currently",
    Potentially = "Potentially",
    None = "None",
    NotConsided = "NotConsided",
}

export enum HealthCareType {
    Communication_ProblemsWithCommunication = "Communication_ProblemsWithCommunication",
    FunctionLevel_ProblemsWithPersonalCare = "FunctionLevel_ProblemsWithPersonalCare",
    FunctionLevel_ProblemsWithDailyActivities = "FunctionLevel_ProblemsWithDailyActivities",
    KnowledgeAndDevelopment_MemoryProblems = "KnowledgeAndDevelopment_MemoryProblems",
    KnowledgeAndDevelopment_ProblemsWithDiseaseInsight = "KnowledgeAndDevelopment_ProblemsWithDiseaseInsight",
    KnowledgeAndDevelopment_ProblemsWithInsightIntoTreatmentPurposes = "KnowledgeAndDevelopment_ProblemsWithInsightIntoTreatmentPurposes",
    KnowledgeAndDevelopment_CognitiveProblems = "KnowledgeAndDevelopment_CognitiveProblems",
    MovementApparatus_ProblemsWithMobilityAndMovement = "MovementApparatus_ProblemsWithMobilityAndMovement",
    Nutrition_ProblemsWithFluidIntake = "Nutrition_ProblemsWithFluidIntake",
    Nutrition_ProblemsWithFoodIntake = "Nutrition_ProblemsWithFoodIntake",
    Nutrition_InappropriateWeightChange = "Nutrition_InappropriateWeightChange",
    Nutrition_ProblemsWithObesity = "Nutrition_ProblemsWithObesity",
    Nutrition_ProblemsWithUnderweight = "Nutrition_ProblemsWithUnderweight",
    PainAndSensoryImpressions_AcutePain = "PainAndSensoryImpressions_AcutePain",
    PainAndSensoryImpressions_PeriodicPain = "PainAndSensoryImpressions_PeriodicPain",
    PainAndSensoryImpressions_ChronicPain = "PainAndSensoryImpressions_ChronicPain",
    PainAndSensoryImpressions_ProblemsWithTheSenseOfSight = "PainAndSensoryImpressions_ProblemsWithTheSenseOfSight",
    PainAndSensoryImpressions_ProblemsWithTheSenseOfSmell = "PainAndSensoryImpressions_ProblemsWithTheSenseOfSmell",
    PainAndSensoryImpressions_HearingProblems = "PainAndSensoryImpressions_HearingProblems",
    PainAndSensoryImpressions_ProblemsWithTheSenseOfTaste = "PainAndSensoryImpressions_ProblemsWithTheSenseOfTaste",
    PainAndSensoryImpressions_ProblemsWithTheSenseOfTouch = "PainAndSensoryImpressions_ProblemsWithTheSenseOfTouch",
    PsychosocialConditions_ProblemsWithSocializing = "PsychosocialConditions_ProblemsWithSocializing",
    PsychosocialConditions_EmotionalProblems = "PsychosocialConditions_EmotionalProblems",
    PsychosocialConditions_ProblemsWithAbuse = "PsychosocialConditions_ProblemsWithAbuse",
    PsychosocialConditions_MentalProblems = "PsychosocialConditions_MentalProblems",
    RespirationAndCirculation_RespiratoryProblems = "RespirationAndCirculation_RespiratoryProblems",
    RespirationAndCirculation_CirculatoryProblems = "RespirationAndCirculation_CirculatoryProblems",
    SeparationOfWasteProducts_ProblemsWithUrination = "SeparationOfWasteProducts_ProblemsWithUrination",
    SeparationOfWasteProducts_ProblemsWithUrinaryIncontinence = "SeparationOfWasteProducts_ProblemsWithUrinaryIncontinence",
    SeparationOfWasteProducts_ProblemsWithStoolIncontinence = "SeparationOfWasteProducts_ProblemsWithStoolIncontinence",
    SeparationOfWasteProducts_StomachAndIntestinalProblems = "SeparationOfWasteProducts_StomachAndIntestinalProblems",
    Sexuality_ProblemsWithSexuality = "Sexuality_ProblemsWithSexuality",
    SkinAndMucousMembranes_ProblemsWithSurgicalWounds = "SkinAndMucousMembranes_ProblemsWithSurgicalWounds",
    SkinAndMucousMembranes_ProblemsWithDiabeticUlcers = "SkinAndMucousMembranes_ProblemsWithDiabeticUlcers",
    SkinAndMucousMembranes_ProblemsWithCancerousLesions = "SkinAndMucousMembranes_ProblemsWithCancerousLesions",
    SkinAndMucousMembranes_ProblemsWithPressureUlcers = "SkinAndMucousMembranes_ProblemsWithPressureUlcers",
    SkinAndMucousMembranes_ProblemsWithArterialUlcer = "SkinAndMucousMembranes_ProblemsWithArterialUlcer",
    SkinAndMucousMembranes_ProblemsWithVenousUlcer = "SkinAndMucousMembranes_ProblemsWithVenousUlcer",
    SkinAndMucousMembranes_ProblemsWithMixedWounds = "SkinAndMucousMembranes_ProblemsWithMixedWounds",
    SkinAndMucousMembranes_ProblemsWithTraumaWounds = "SkinAndMucousMembranes_ProblemsWithTraumaWounds",
    SkinAndMucousMembranes_OtherSkinAndMucousMembraneProblems = "SkinAndMucousMembranes_OtherSkinAndMucousMembraneProblems",
    SleepAndRest_CircadianRhythmProblems = "SleepAndRest_CircadianRhythmProblems",
    SleepAndRest_SleepProblems = "SleepAndRest_SleepProblems",
    None = "None",
}

export interface HttpContent {
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;
}

export interface HttpMethod {
    method?: string | undefined;
}

export interface HttpRequestMessage {
    version?: Version | undefined;
    versionPolicy?: HttpVersionPolicy | undefined;
    content?: HttpContent | undefined;
    method?: HttpMethod | undefined;
    requestUri?: string | undefined;
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly properties?: { [key: string]: any; } | undefined;
    readonly options?: { [key: string]: any; } | undefined;
}

export interface HttpResponseMessage {
    version?: Version | undefined;
    content?: HttpContent | undefined;
    statusCode?: HttpStatusCode | undefined;
    reasonPhrase?: string | undefined;
    readonly headers?: StringStringIEnumerableKeyValuePair[] | undefined;
    readonly trailingHeaders?: StringStringIEnumerableKeyValuePair[] | undefined;
    requestMessage?: HttpRequestMessage | undefined;
    readonly isSuccessStatusCode?: boolean | undefined;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export enum HttpVersionPolicy {
    RequestVersionOrLower = "RequestVersionOrLower",
    RequestVersionOrHigher = "RequestVersionOrHigher",
    RequestVersionExact = "RequestVersionExact",
}

export interface Measurement {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    citizenEnrollmentId: string;
    citizenId?: string | undefined;
    remarks?: string | undefined;
    measurementType: MeasurementType;
    fromDate: Date;
    toDate: Date;
    date?: Date | undefined;
    diastolisk?: number | undefined;
    systolisk?: number | undefined;
    puls?: number | undefined;
    millimol?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    confusion?: number | undefined;
    irritability?: number | undefined;
    loudBehavior?: number | undefined;
    verbalThreats?: number | undefined;
    physicalThreats?: number | undefined;
    attack?: number | undefined;
    m1?: number | undefined;
    bodyTemperature?: number | undefined;
    riskAssessment?: RiskAssessment | undefined;
    description?: string | undefined;
    whatHappendText?: string | undefined;
    whatDidYouDoText?: string | undefined;
}

export interface MeasurementDto {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    citizenEnrollmentId: string;
    citizenId?: string | undefined;
    remarks?: string | undefined;
    measurementType: MeasurementType;
    fromDate: Date;
    toDate: Date;
    date?: Date | undefined;
    diastolisk?: number | undefined;
    systolisk?: number | undefined;
    puls?: number | undefined;
    millimol?: number | undefined;
    height?: number | undefined;
    weight?: number | undefined;
    confusion?: number | undefined;
    irritability?: number | undefined;
    loudBehavior?: number | undefined;
    verbalThreats?: number | undefined;
    physicalThreats?: number | undefined;
    attack?: number | undefined;
    m1?: number | undefined;
    bodyTemperature?: number | undefined;
    riskAssessment?: RiskAssessment | undefined;
    description?: string | undefined;
    whatHappendText?: string | undefined;
    whatDidYouDoText?: string | undefined;
    citizens?: Citizen[] | undefined;
    citizen?: Citizen | undefined;
}

export enum MeasurementType {
    Bloodsugar = "Bloodsugar",
    Bloodpressure = "Bloodpressure",
    Bmi = "Bmi",
    Temperature = "Temperature",
    Trafficlight = "Trafficlight",
    Bvc = "Bvc",
    Liquid = "Liquid",
}

export interface Medicine {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    fromDate: Date;
    toDate: Date;
    doseUnit: DoseUnit;
    cave?: string | undefined;
    product: Product;
    citizenId: string;
    citizenEnrollmentId: string;
    medicineType: MedicineType;
    schedules?: string | undefined;
    dailyDose?: string | undefined;
    maxDailyDose?: string | undefined;
    actualDose?: string | undefined;
    medicineStates?: MedicineState[] | undefined;
    incDecStartDose?: string | undefined;
    incDecEndDose?: string | undefined;
    incDecEveryX?: string | undefined;
    incDecDose?: string | undefined;
    noCalendarItem?: boolean | undefined;
    note?: string | undefined;
}

export enum MedicinePassout {
    Awaits = "Awaits",
    PassedOut = "PassedOut",
    PassedOutFailed = "PassedOutFailed",
}

export interface MedicineState {
    medicinePassout?: MedicinePassout | undefined;
    passoutFailedExplanation?: string | undefined;
    doze?: string | undefined;
    timeStamp?: Date | undefined;
}

export enum MedicineType {
    DoseDispensing = "DoseDispensing",
    Brought = "Brought",
    PN = "PN",
    SelfAdministered = "SelfAdministered",
    BySchema = "BySchema",
    Increasing = "Increasing",
    Decreasing = "Decreasing",
    PNSelfAdministered = "PNSelfAdministered",
    PNBrought = "PNBrought",
    PrescribedMedicine = "PrescribedMedicine",
}

export interface Note {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    citizenEnrollmentId?: string | undefined;
    citizenId?: string | undefined;
    departmentId?: string | undefined;
    text?: string | undefined;
    health?: HealthCareType[] | undefined;
    fromDate: Date;
    toDate: Date;
    subGoalId?: string | undefined;
}

export interface NoteDto {
    citizenEnrollmentId?: string | undefined;
    citizenId?: string | undefined;
    departmentId?: string | undefined;
    text?: string | undefined;
    health?: HealthCareType[] | undefined;
    fromDate: Date;
    toDate: Date;
    goal?: Goal | undefined;
    citizenName?: string | undefined;
    citizens?: Citizen[] | undefined;
    createdByName?: string | undefined;
    modifiedByName?: string | undefined;
    id?: string | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    subGoalId?: string | undefined;
    departments?: Department[] | undefined;
    citizen?: Citizen | undefined;
    department?: Department | undefined;
    createdBy?: string | undefined;
}

export enum Position {
    Administration = "Administration",
    HeadOfDepartment = "HeadOfDepartment",
    Assistant = "Assistant",
    OccupationalTherapist = "OccupationalTherapist",
    HomeSupervisor = "HomeSupervisor",
    ITEmployee = "ITEmployee",
    Consultant = "Consultant",
    Coordinator = "Coordinator",
    NightEmployee = "NightEmployee",
    CareAssistant = "CareAssistant",
    OrganizationalseniorLeader = "OrganizationalseniorLeader",
    SeniorClerk = "SeniorClerk",
    Pedagogue = "Pedagogue",
    TeachingAssistant = "TeachingAssistant",
    ServicePersonnel = "ServicePersonnel",
    SocialAndHealthAssistant = "SocialAndHealthAssistant",
    SocialAndHealthCare = "SocialAndHealthCare",
    SocialWorker = "SocialWorker",
    Student = "Student",
    Nurse = "Nurse",
    TeamLeader = "TeamLeader",
    Substitute = "Substitute",
    WorkshopEmployee = "WorkshopEmployee",
}

export interface Product {
    navn?: string | undefined;
    varenummer?: string | undefined;
    firma?: string | undefined;
    styrke?: string | undefined;
    detaljer?: string | undefined;
    pakning?: string | undefined;
}

export interface ProductDetails {
    navn?: string | undefined;
    varenummer?: string | undefined;
    styrke?: string | undefined;
    pakning?: string | undefined;
    virksomtStof?: string | undefined;
    firma?: string | undefined;
    atcKode?: string | undefined;
    dosisdispensering?: boolean | undefined;
    udleveringsgruppe?: string | undefined;
    prisPrPakning?: number | undefined;
    prisPrEnhed?: number | undefined;
    aip?: number | undefined;
    tilskudBeregnesAf?: number | undefined;
    udgaaet?: boolean | undefined;
    udgaaetDato?: Date | undefined;
    substitutioner?: Product[] | undefined;
    billigereKombinationer?: Product[] | undefined;
    dosering?: string | undefined;
    indikation?: string | undefined;
    trafikAdvarsel?: boolean | undefined;
    ddd?: number | undefined;
    opbevaringsbetingelser?: string | undefined;
    nbsSpeciale?: string | undefined;
    haandkoeb?: boolean | undefined;
    tilskudKode?: string | undefined;
    tilskudTekst?: string | undefined;
}

export interface ResourceCalendarItem {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    resourceCalendarItemType: ResourceCalendarItemType;
    resourceCalendarPage: ResourceCalendarPage;
    fromDate: Date;
    toDate: Date;
    employeeId: string;
    overrideHours?: string | undefined;
    fullDay?: boolean | undefined;
    departmentId: string;
    dayNumber?: number | undefined;
}

export enum ResourceCalendarItemType {
    Administrative = "Administrative",
    Relaxation = "Relaxation",
    TheChildFirstSickDay = "TheChildFirstSickDay",
    TheChildSecondSickDay = "TheChildSecondSickDay",
    PaidTimeOff = "PaidTimeOff",
    Vacation = "Vacation",
    Vacation6 = "vacation6",
    Course = "Course",
    StandardHours = "StandardHours",
    CaringDay = "CaringDay",
    LeaveOfAbsence = "LeaveOfAbsence",
    Overtime = "Overtime",
    SeniorLessons = "SeniorLessons",
    Sick = "Sick",
    ProtectedDayOff = "ProtectedDayOff",
}

export enum ResourceCalendarPage {
    Template = "Template",
    Draft = "Draft",
    Planning = "Planning",
}

export interface Risk {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    riskLevel?: RiskLevel | undefined;
    text?: string | undefined;
    citizenId?: string | undefined;
}

export enum RiskAssessment {
    Green = "Green",
    Yellow = "Yellow",
    Red = "Red",
}

export enum RiskLevel {
    None = "None",
    Medium = "Medium",
    High = "High",
}

export interface StringProductListKeyValuePair {
    key?: string | undefined;
    value?: Product[] | undefined;
}

export interface StringStringIEnumerableKeyValuePair {
    key?: string | undefined;
    value?: string[] | undefined;
}

export interface Tag {
    id?: string | undefined;
    modified?: Date | undefined;
    created?: Date | undefined;
    createdByEnrollment?: string | undefined;
    createdByCenterName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    createdByName?: string | undefined;
    modifiedByEnrollment?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByCenterName?: string | undefined;
    modifiedByDepartmentName?: string | undefined;
    name?: string | undefined;
}

export interface Token {
    token?: string | undefined;
}

export enum TypeOfConviction {
    Domstype1 = "Domstype1",
    Domstype2 = "Domstype2",
    Domstype3 = "Domstype3",
    Domstype4 = "Domstype4",
    Domstype5 = "Domstype5",
    None = "None",
}

export enum UploadType {
    Citizen = "Citizen",
    Employee = "Employee",
    Department = "Department",
    Center = "Center",
    HealtCare = "HealtCare",
    EmployeePicture = "EmployeePicture",
    CitizenPicture = "CitizenPicture",
}

export interface UseOfForceCalculations {
    totalYearCount?: number | undefined;
    daysSince?: number | undefined;
}

export interface UseOfForceDto {
    id?: string | undefined;
    documentName?: string | undefined;
    status?: UseOfForceStatus | undefined;
    fromEmployeeEnrollment?: string | undefined;
    ownerEmployeeEnrollment?: string | undefined;
    version?: string | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    createdByName?: string | undefined;
    createdByDepartmentName?: string | undefined;
    createdByCenterName?: string | undefined;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    jsonString?: string | undefined;
    citizens?: Citizen[] | undefined;
    citizen?: Citizen | undefined;
}

export enum UseOfForceStatus {
    Employee = "Employee",
    DepartmentManager = "DepartmentManager",
    CenterManager = "CenterManager",
    Authority = "Authority",
}

export interface Version {
    readonly major?: number | undefined;
    readonly minor?: number | undefined;
    readonly build?: number | undefined;
    readonly revision?: number | undefined;
    readonly majorRevision?: number | undefined;
    readonly minorRevision?: number | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

// @ts-ignore

export default {
  calendarItem : new CalendarItemClient(),
  center : new CenterClient(),
  citizen : new CitizenClient(),
  citizenEnrollment : new CitizenEnrollmentClient(),
  department : new DepartmentClient(),
  departmentCitizenEnrollment : new DepartmentCitizenEnrollmentClient(),
  employee : new EmployeeClient(),
  employeeEnrollment : new EmployeeEnrollmentClient(),
  favorite : new FavoriteClient(),
  file : new FileClient(),
  forgotPassword : new ForgotPasswordClient(),
  forum : new ForumClient(),
  frontEndErrorLogger : new FrontEndErrorLoggerClient(),
  goal : new GoalClient(),
  goalScorer : new GoalScorerClient(),
  healthCare : new HealthCareClient(),
  keepAlive : new KeepAliveClient(),
  measurement : new MeasurementClient(),
  medicine : new MedicineClient(),
  note : new NoteClient(),
  resourceCalendar : new ResourceCalendarClient(),
  risk : new RiskClient(),
  tag : new TagClient(),
  token : new TokenClient(),
  useOfForce : new UseOfForceClient(),
}